/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext, useEffect, useState } from 'react';
import capitalise from '../../utils/capitalise';
import '../TopCabsRoutes/TopCabsRoutes.css';
import './RouteCabsV2.css';
import { Context } from '../../AppContext';
import { ORDER_FIELD } from '../../constants/miscellaneousConstants';
import { RouteCabsV2Desktop } from './RouteCabsV2Desktop';
import { RouteCabsV2Mobile } from './RouteCabsV2Mobile';
import { CabData, TripBenefit } from '../../pages/runtime-typechecker';
import { getCmpFromUrl } from '../../utils/commonUtils';

type RouteCabsV2 = {
  data: CabData[] | undefined | null;
  seoUrl: string | null | undefined;
  sourceCityName: string;
  destinationCityName: string;
  packageAvailabilityOrderMap: Map<number, boolean>;
  setPackageAvailabilityOrderMap: (idx: number, val: boolean) => void;
  isShown: (cabInfo) => boolean;
  tripBenefits: TripBenefit[] | undefined | null;
  isMobileDevice: boolean;
  topRoutesInfoFromSourceToDestinationIsomorphic: any;
};

const RouteCabsV2 = ({
  tripBenefits,
  packageAvailabilityOrderMap,
  setPackageAvailabilityOrderMap,
  data,
  sourceCityName,
  destinationCityName,
  topRoutesInfoFromSourceToDestinationIsomorphic,
  isShown
}: RouteCabsV2) => {
  const getModelDescriptionString = (description: string) => {
    const descriptionStringMap = {
      'Similar Model': 'or similar',
      'Specific Model': 'specific model'
    };
    return descriptionStringMap[description]
      ? descriptionStringMap[description]
      : description.toLowerCase();
  };
  const getModelNameString = (modelName: string) => {
    if (modelName == 'GENERIC') {
      return modelName;
    }
    return capitalise(modelName);
  };
  const redirect = (url: string | null | undefined) => {
    if (!url) return;
    const cmp = getCmpFromUrl();
    // For webview Implementation as Saurav
    const rediectionUrl = `${url}&${omniUrlArgs}&cmp=${cmp}`;

    window.location = Object(rediectionUrl);
  };

  const getFirstVisibleCardIndex = () => {
    let firstVisibleCardIndex = -1;
    if (data && data.length > 0) {
      for (const cabInfo of data) {
        if (isShown(cabInfo)) {
          firstVisibleCardIndex = cabInfo[ORDER_FIELD];
          break;
        }
      }
    }
    return firstVisibleCardIndex;
  };

  const { omniUrlArgs } = useContext(Context);
  return (
    <>
      <div className="desktopShow">
        <span>
          <h2 className="routeCabsV2Header">{`${sourceCityName} to ${destinationCityName} ${(() => {
            if (topRoutesInfoFromSourceToDestinationIsomorphic.oneWayDistance) {
              return `one way distance ${topRoutesInfoFromSourceToDestinationIsomorphic.oneWayDistance} kms |`;
            } else {
              return '';
            }
          })()} One way duration ${
            topRoutesInfoFromSourceToDestinationIsomorphic.oneWayDurationInHrMins
          }`}</h2>
        </span>
        <RouteCabsV2Desktop
          isShown={isShown}
          data={data}
          packageAvailabilityOrderMap={packageAvailabilityOrderMap}
          setPackageAvailabilityOrderMap={setPackageAvailabilityOrderMap}
          getModelNameString={getModelNameString}
          getModelDescriptionString={getModelDescriptionString}
          getFirstVisibleCardIndex={getFirstVisibleCardIndex}
          redirect={redirect}
          tripBenefits={tripBenefits}
        />
      </div>
      <div style={{ display: 'none' }} className="mobileShow">
        <span className="makeBlock">
          <span>
            <h2 className="routeCabsV2Header">
              {`${sourceCityName} to ${destinationCityName} ${(() => {
                if (
                  topRoutesInfoFromSourceToDestinationIsomorphic.oneWayDistance
                ) {
                  return `one way distance ${topRoutesInfoFromSourceToDestinationIsomorphic.oneWayDistance} kms |`;
                } else {
                  return '';
                }
              })()}`}
              <br />
              {`One way duration ${topRoutesInfoFromSourceToDestinationIsomorphic.oneWayDurationInHrMins}`}
            </h2>
          </span>
        </span>
        <RouteCabsV2Mobile data={data} redirect={redirect} />
      </div>
    </>
  );
};

export default RouteCabsV2;
